import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendAlert } from '../../../actions/utils';

import { indexCompanyRequest, exportActiveCompaniesRequest } from '../../../requests/companies';
import { ButtonTooltip, ComponentDataTable, DefaultModal, Icon } from '../../../components';
import { downloadFile } from '../../../services/utils';

const CompanyDataTableDt = ({ columns, moreData, setMoreData }) => {
  const [onRequest, setOnRequest] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [amount, setAmount] = useState(0);
  const [modalTitle, setModalTitle] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalBody, setModalBody] = useState('');
  const [query, setQuery] = useState({});
  const dispatch = useDispatch();

  const handleSuccessIndex = response => {
    const { data, metadata } = response.data;
    setCompanies(data);
    setAmount(metadata.amount);
    setOnRequest(false);
  };

  const handleRequest = params => {
    setMoreData(false);
    const customParams = {
      ...params,
      active: true,
      with_attendance_management: true,
      status: 1,
      is_parent: true,
      paginate: false
    };

    setQuery(customParams);
    setOnRequest(true);
    indexCompanyRequest({
      params: customParams,
      dispatch,
      successCallback: handleSuccessIndex
    });
  };

  const handleFailureRequest = error => {
    dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
    setModalShow(false);
    setOnRequest(false);
  };

  const handleDownload = () => {
    setOnRequest(true);
    exportActiveCompaniesRequest({
      dispatch,
      params: { ...query, paginate: false },
      successCallback: response => {
        setModalShow(false);
        downloadFile(response);
        setOnRequest(false);
      },
      failureCallback: handleFailureRequest
    });
  };

  const handleMassAction = action => {
    switch (action) {
      case 'export':
        setModalTitle('Exportar Empresas Vigentes');
        setModalShow(true);
        setModalBody('¿Estás seguro que quieres exportar las empresas vigentes formato Excel?');
        break;
      default:
        // eslint-disable-next-line no-console
        console.log('Error: Action not found');
    }
  };

  const sortColumnCase = name => {
    switch (name) {
      case 'created_at':
        return {
          sort_column: 'national_identification',
          sort_direction: 'asc'
        };
      default:
        return { sort_column: name };
    }
  };

  return (
    <>
      <ComponentDataTable
        onRequest={onRequest}
        columns={columns()}
        data={companies}
        totalRows={amount}
        moreData={moreData}
        pointerOnHover
        resourceRequest={handleRequest}
        handleSortCase={sortColumnCase}
        massActions={
          <>
            <ButtonTooltip
              variant="circle-primary"
              className="mr-2 mb-3 mt-2 btn-circle"
              text="Exportar"
              onClick={() => handleMassAction('export')}
            >
              <Icon icon="download-2" />
            </ButtonTooltip>
          </>
        }
        withMassActions
      />
      <DefaultModal
        title={modalTitle}
        body={modalBody}
        show={modalShow}
        handleClose={() => setModalShow(false)}
        handleConfirm={() => handleDownload()}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
      />
    </>
  );
};

export default CompanyDataTableDt;
